import { Microfrontend } from '@cian/mf-react';
import { IMicrofrontendManifest } from '@cian/mf-registry/shared';

import * as React from 'react';

import { TAdBannerMicrofrontendParameters, TAdBannerPlaceParameters } from '../../types/adBannerMicrofrontend';
import { AdBannerPlaceholder } from './components/AdBannerPlaceholder';
import { useAdBannerCommonParameters, useAdBannerMicrofrontend, useAdBannerMicrofrontendEvents } from './hooks';

export type TAdBannerMicrofrontendContainerProps = {
  manifest: IMicrofrontendManifest;
  parameters: TAdBannerPlaceParameters;
  onLoad?(): void;
  onStub?(): void;
  onError?(): void;
  onClose?(): void;
};

/**
 * Generic-контейнер микрофронтенда ad-banner-frontend: ничего не знает о конкретном месте.
 * Резолвит общие параметры (puids, regionId, placeId), резервирует место плейсхолдером
 * и монтирует микрофронтенд только на клиенте.
 */
export const AdBannerMicrofrontendContainer: React.FC<TAdBannerMicrofrontendContainerProps> = ({
  manifest,
  parameters,
  onLoad,
  onStub,
  onError,
  onClose,
}) => {
  const { microfrontendRef, isReady } = useAdBannerMicrofrontend();
  const commonParameters = useAdBannerCommonParameters();

  useAdBannerMicrofrontendEvents({
    isReady,
    onClose,
    onError,
    onLoad,
    onStub,
    placeId: commonParameters.placeId,
  });

  const { microfrontendName, imageVersion, runtimeName } = manifest;

  // Общие параметры — база, параметры места перекрывают их. useMemo держит ссылку стабильной,
  // иначе микрофронтенд будет ре-рендериться на каждый рендер хоста.
  const mergedParameters = React.useMemo(
    (): TAdBannerMicrofrontendParameters => ({ ...commonParameters, ...parameters }),
    [parameters, commonParameters],
  );

  return (
    <AdBannerPlaceholder sizes={parameters.sizes} testId={`AdBannerMicrofrontend-${parameters.place}`}>
      {isReady && (
        <Microfrontend
          ref={microfrontendRef}
          name={microfrontendName}
          image={imageVersion}
          runtime={runtimeName}
          parameters={mergedParameters}
        />
      )}
    </AdBannerPlaceholder>
  );
};
